module.exports = __webpack_public_path__ + "img/xuwenli.6d5c1cd2.jpg";